









































import { TypeBody, TypeDisplay, TabControls, BaseTag } from '@bambeehr/pollen';
import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Pills',
  components: {
    TypeBody,
    TypeDisplay,
    TabControls,
    BaseTag,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    currentOption: {
      type: String,
      required: true,
    },
  },
  setup({ currentOption }, { emit }) {
    const plan = ref(currentOption);

    const handleTabChange = (event: any) => {
      if (event?.target?.id) {
        emit('handleTabChange', event.target.id);
      }
    };

    return {
      plan,
      handleTabChange,
    };
  },
});
